import { GRAYS } from '../constants/colors';

export const updateFavicon = () => {
  const colors = GRAYS;

  const favicon = document.createElement('link');
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  favicon.type = 'image/png';
  favicon.rel = 'shortcut icon';

  canvas.width = 64;
  canvas.height = 64;

  ctx.fillStyle = colors[0].background;
  ctx.fillRect(0, 0, canvas.width * 0.75, canvas.height * 0.5);

  ctx.fillStyle = colors[1].background;
  ctx.fillRect(
    canvas.width * 0.75,
    0,
    canvas.width * 0.25,
    canvas.height * 0.5
  );
  ctx.fillRect(
    0,
    canvas.height * 0.5,
    canvas.width * 0.25,
    canvas.height * 0.5
  );

  ctx.fillStyle = colors[2].background;
  ctx.fillRect(
    canvas.width * 0.25,
    canvas.height * 0.5,
    canvas.width * 0.75,
    canvas.height * 0.5
  );

  favicon.href = canvas.toDataURL();

  // Remove any existing favicons
  [...document.querySelectorAll('link[rel="shortcut icon"]')].forEach((el) =>
    el.remove()
  );

  // Add the new one
  document.head.appendChild(favicon);
};
